export default {"src":"https://cdn-student.writinglegends.com/_next/static/media/frog.2d0416e5.svg","height":768,"width":1366,"blurWidth":0,"blurHeight":0};